import { IonButton, IonButtons, IonCheckbox, IonContent, IonFooter, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonMenuButton, IonNote, IonPage, IonSelect, IonSelectOption, IonTitle, IonToolbar, useIonToast } from "@ionic/react"
import { useFormik } from "formik"
import { useEffect, useState } from "react"
import { useHistory, useLocation } from "react-router"
import * as Yup from "yup"
import { Group, compareGroupWith } from "../../../dto/group"
import { GroupData, findData, save } from "./service"
import { checkmarkDoneOutline, squareOutline } from "ionicons/icons"

const GroupForm: React.FC = () => {

  const [toast] = useIonToast()
  const history = useHistory()
  const location = useLocation()
  let groupState = location?.state as Group 
  const [data, setData] = useState({} as GroupData)

  useEffect(() => {
    const init = async () => {
      const data = await findData(groupState.id)
      formik.setValues(data.group)
      setData(data)
    }
    init()
  }, [])

  const onSubmit = async (group: Group) => {
    await save(group)
    history.replace('/group/list', { refresh: true })

    toast({
      message: "Grupo '" + group.name + "' editado com sucesso.",
      duration: 1_500,
      position: 'top'
    })
  }

  const requiredError = 'Campo obrigatório.'
  const lengthError = 'Mínimo de 4 caracteres.'

  let valid: any = {
    name: Yup.string().required(requiredError).min(4, lengthError),
    isShowMargem: Yup.bool(),
    users: Yup.array(),
    stores: Yup.array(),
  }

  const formik = useFormik({
    initialValues: data.group,
    onSubmit: onSubmit,
    validationSchema: Yup.object().shape(valid),
    validateOnMount: true,
    enableReinitialize: false
  })

  if (!data.group) {
    return <></>
  }

  const buildInput = (label: string, name: string, type: any = "text") => {
    const val: any = formik.values
    const erros: any = formik.errors
    const msm = erros[name]

    return <IonItem className={`${!msm && 'ion-valid'} ${msm && 'ion-invalid ion-touched'}`}>
      <IonLabel position="stacked">{label}</IonLabel>

      <IonInput
        name={name}
        value={val ? val[name] : ''} 
        type={type}
        onIonChange={formik.handleChange}
        onIonBlur={formik.handleBlur}
      />

      {msm &&
        <IonNote slot="error" style={{ color: 'var(--ion-color-danger)', textAlign : 'right', width : '100%',  }}>{msm}</IonNote>
      }
    </IonItem>
  }

  const buildContent = () => {
    return (
      <form onSubmit={formik.handleSubmit} style={{margin:"0.5em"}}>
        {buildInput("Nome", "name")}

        <IonItem>
          <IonCheckbox
            checked={formik.values.isShowMargem}
            onIonChange={(e) => { formik.setFieldValue("isShowMargem", e.detail.checked) }}
            slot="start"
          />
          <IonLabel style={{ marginLeft: "1em" }}>Usuários deste grupo podem visualizar informações sobre margem.</IonLabel>
        </IonItem>

        <IonItem>
          <IonLabel>Usuários : </IonLabel>

          <IonSelect onIonChange={(e: any) => { formik.setFieldValue("users", e.detail.value) }}
            value={formik.values.users} multiple={true} compareWith={compareGroupWith}>

            {data!.allUsers!.map((user) => (
              <IonSelectOption key={user.id} value={user}>
                {user.email}
              </IonSelectOption>
            ))}
          </IonSelect>
        </IonItem>

        <IonToolbar className='filter-white'>
          <IonButtons slot="end" style={{ marginRight: '2em' }}>
            <IonButton onClick={() => { formik.setFieldValue('users', []) }} >
              <IonIcon icon={squareOutline} />
            </IonButton>
            <IonButton onClick={() => { formik.setFieldValue('users', data!.allUsers) }} >
              <IonIcon icon={checkmarkDoneOutline} />
            </IonButton>
          </IonButtons>
        </IonToolbar>

        <IonItem>
          <IonLabel>Lojas : </IonLabel>

          <IonSelect onIonChange={(e: any) => { formik.setFieldValue("stores", e.detail.value) }}
            value={formik.values.stores} multiple={true} compareWith={compareGroupWith}>

            {data!.allStores!.map((store) => (
              <IonSelectOption key={store.id} value={store}>
                {store.name}
              </IonSelectOption>
            ))}
          </IonSelect>
        </IonItem>

        <IonToolbar className='filter-white'>
          <IonButtons slot="end" style={{ marginRight: '2em' }}>
            <IonButton onClick={() => { formik.setFieldValue('stores', []) }} >
              <IonIcon icon={squareOutline} />
            </IonButton>
            <IonButton onClick={() => { formik.setFieldValue('stores', data!.allStores) }} >
              <IonIcon icon={checkmarkDoneOutline} />
            </IonButton>
          </IonButtons>
        </IonToolbar>

      </form>
    )
  }

  return (
    <IonPage>
      <IonHeader style={{ marginBottom: "1em" }}>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle style={{marginLeft: "1em"}}>Grupo</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        {buildContent()}
      </IonContent>

      <IonFooter>
        <IonToolbar style={{color : 'white'}} >
        
          <IonButtons slot="start">
            <IonButton onClick={() => { history.replace('/group/list', { refresh: true }) }} >
              Cancelar
            </IonButton>
          </IonButtons>

          <IonButtons slot="end">

            <IonButton disabled={!formik.isSubmitting && (Array.isArray(formik.errors) || Object.values(formik.errors).toString() !== "")}
              onClick={() => {
                formik.handleSubmit()
              }}>
              Salvar
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  )
}

export default GroupForm
